export default "e7861e54be98d3bb.svg"